module.exports = __webpack_public_path__ + "static/assets/d8baa2e6de54aedc8ff9fcb31bacfdb5.png";